import { ApolloLink, Observable } from '@apollo/client';
import { mockEvents } from './notificationData';
import {
    getStoredNotifications,
    handleCreateNotification,
    handleUpdateNotification,
    handleDeleteNotification,
    handleRestoreNotification,
    handleToggleNotification,
    handleBulkToggle
} from './mockHandlers';

const MOCKED_OPERATIONS = new Set([
    'FindNotifications',
    'GetNotificationEvents',
    'CreateNotification',
    'UpdateNotification',
    'DeleteNotification',
    'RestoreNotification',
    'ToggleNotification',
    'BulkToggleNotifications'
]);

export const createMockLink = () =>
    new ApolloLink((operation, forward) => {
        const operationName = operation.operationName;

        if (!MOCKED_OPERATIONS.has(operationName)) {
            return forward(operation);
        }

        return new Observable((observer) => {
            const delay = 300;

            setTimeout(() => {
                try {
                    let result;

                    switch (operationName) {
                        case 'FindNotifications':
                            result = {
                                data: {
                                    findNotifications: getStoredNotifications()
                                }
                            };
                            break;

                        case 'GetNotificationEvents': {
                            const { recordTypeId } = operation.variables;
                            result = {
                                data: {
                                    getNotificationEvents: mockEvents[recordTypeId] || []
                                }
                            };
                            break;
                        }

                        case 'CreateNotification':
                            result = {
                                data: {
                                    createNotification: handleCreateNotification(operation.variables)
                                }
                            };
                            break;

                        case 'UpdateNotification':
                            result = {
                                data: {
                                    updateNotification: handleUpdateNotification(operation.variables)
                                }
                            };
                            break;

                        case 'DeleteNotification':
                            result = {
                                data: {
                                    deleteNotification: handleDeleteNotification(operation.variables)
                                }
                            };
                            break;

                        case 'RestoreNotification':
                            result = {
                                data: {
                                    restoreNotification: handleRestoreNotification(operation.variables)
                                }
                            };
                            break;

                        case 'ToggleNotification':
                            result = {
                                data: {
                                    toggleNotification: handleToggleNotification(operation.variables)
                                }
                            };
                            break;

                        case 'BulkToggleNotifications':
                            result = {
                                data: {
                                    bulkToggleNotifications: handleBulkToggle(operation.variables)
                                }
                            };
                            break;

                        default:
                            observer.error({
                                graphQLErrors: [{ message: 'Operation not mocked' }]
                            });
                            return;
                    }

                    observer.next(result);
                    observer.complete();
                } catch (error: any) {
                    observer.error({
                        graphQLErrors: [{ message: error.message }]
                    });
                }
            }, delay);
        });
    });
